import * as React from 'react';
import Loading, { FontSize } from '../../misc/components/loading';

export interface AsyncActionButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    isSubmitting: boolean;
    isDisabled?: boolean;
}

export const AsyncActionButton = ({ isSubmitting, isDisabled, children, ...rest }: AsyncActionButtonProps) => {
    return (
        <button
            disabled={isSubmitting || isDisabled}
            data-automationid="AsyncActionButton"
            {...rest}
        >
            {isSubmitting ? <Loading size={FontSize.OneX} style={{ display: "inline-block" }} /> : null}
            &nbsp;
            {children}
        </button>
    );
}

export default AsyncActionButton;
